<script setup lang="ts">

definePageMeta({
  static: true,
  title: 'Sobre Nós'
})

const breadcrumbData = [{
  title: 'Home',
  link: '/',
  subitems: [
    {title: 'Sobre-nós'}
  ]
}]
</script>

<template>
  <AboutUsPnav/>
  <div class="container mt-5 mb-3">
    <h2 class="text-center h2">Os valores pelos quais vivemos</h2>
    <p class="mb-4 pb-2 mx-auto fs-lg text-center">
      Tudo começou com uma paixão: conectar pessoas através de experiências incríveis. Nossa empresa nasceu para ser a
      ponte entre quem produz eventos e quem vive cada momento com intensidade. Somos mais do que uma plataforma de
      ingressos — somos uma solução digital completa, pensada para simplificar a gestão de eventos e potencializar cada
      etapa, do primeiro ingresso vendido ao último aplauso. Aqui, produtores encontram ferramentas inteligentes para
      organizar, vender e encantar, enquanto o público descubre acesso fácil a experiências plurais e memoráveis. Porque
      acreditamos que, quando a tecnologia e a cultura se encontram, nascem histórias inesquecíveis.
    </p>
  </div>
  <AboutUsWhyChooseUs class="pt-5"/>
  <!--  <AboutUsBrand/>-->
</template>
